import React, { useState } from "react";
import Swal from "sweetalert2";
import { Auth_Proto, Auth_Domain, Auth_Port } from "../Component/consts";

// Legacy one-time order payment (kept for /paymentgateway route).
// Uses gateway -> masters RazorpayPaymentController (/payments/create-order, /payments/verify-payment).
const PaymentGateway = ({ handlePaymentUpdate, amount = 500, currency = "INR" }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handlePayment = async () => {
    const razorKey = process.env.REACT_APP_RAZOR_PAY_KEY;
    if (!razorKey) {
      Swal.fire("Razorpay key missing in .env (REACT_APP_RAZOR_PAY_KEY).", "", "error");
      return;
    }
    if (!window.Razorpay) {
      Swal.fire("Razorpay SDK not loaded.", "", "error");
      return;
    }
    setIsLoading(true);
    try {
      const base = `${Auth_Proto}${Auth_Domain}${Auth_Port}/api/masters`;
      const response = await fetch(`${base}/payments/create-order`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ amount, currency, receipt: `txn_${Date.now()}` }),
      });
      const data = await response.json();
      const orderId = data.id || data.orderId;
      if (!orderId) {
        throw new Error(data?.error || "Failed to create order. Please try again.");
      }

      const options = {
        key: razorKey,
        amount: data.amount,
        currency: data.currency || currency,
        name: "Finanzz",
        description: "One-time payment",
        order_id: orderId,
        handler: async function (rzpResponse) {
          try {
            const verifyResponse = await fetch(`${base}/payments/verify-payment`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(rzpResponse),
            });
            const verifyData = await verifyResponse.json();
            if (verifyResponse.ok && verifyData.status === "Payment verified successfully") {
              Swal.fire("Payment successful!", "", "success");
              if (handlePaymentUpdate) handlePaymentUpdate(true);
            } else {
              Swal.fire(verifyData?.error || verifyData?.status || "Payment verification failed!", "", "error");
              if (handlePaymentUpdate) handlePaymentUpdate(false);
            }
          } catch (e) {
            Swal.fire("Payment verification failed!", "", "error");
            if (handlePaymentUpdate) handlePaymentUpdate(false);
          } finally {
            setIsLoading(false);
          }
        },
        prefill: { name: "Customer", email: "customer@example.com", contact: "9999999999" },
        theme: { color: "#3399cc" },
      };

      const rzp = new window.Razorpay(options);
      rzp.on("payment.failed", function (resp) {
        Swal.fire("Payment failed. Please try again.", "", "error");
        console.error(resp?.error);
        if (handlePaymentUpdate) handlePaymentUpdate(false);
        setIsLoading(false);
      });
      setIsLoading(false);
      rzp.open();
    } catch (e) {
      console.error(e);
      Swal.fire(e.message || "An error occurred. Please try again.", "", "error");
      if (handlePaymentUpdate) handlePaymentUpdate(false);
      setIsLoading(false);
    }
  };

  return (
    <div>
      <button
        onClick={handlePayment}
        disabled={isLoading}
        className="tw-flex tw-mt-3 tw-justify-center tw-text-black tw-bg-[#FDD60E] tw-rounded-xl tw-py-1.5 tw-px-5 disabled:tw-opacity-60"
      >
        {isLoading ? "Processing..." : `Pay ₹${amount}`}
      </button>
    </div>
  );
};

export default PaymentGateway;
